module.exports = __webpack_public_path__ + "settings/userTracker.json";


//////////////////
// WEBPACK FOOTER
// ./Statics/settings/userTracker.json
// module id = 552
// module chunks = 2